import { useMutation, useQueryClient } from '@tanstack/react-query';
import { CourseService } from '@/services';
import { useViewStore } from '@/stores';
import type { FlashcardAndStats, FlashcardDecksAndStats } from '@/types';

export function useRateFlashcard() {
  const queryClient = useQueryClient();
  const { toggleFlashcardAnswer } = useViewStore();

  return useMutation({
    mutationFn: async ({
      courseId,
      deckId,
      flashcardId,
      rating,
    }: {
      courseId: string;
      deckId: string;
      flashcardId: string;
      rating: number;
    }) => {
      const result = await CourseService.rateFlashcard(courseId, deckId, flashcardId, rating);
      return { courseId, deckId, result };
    },
    onSuccess: ({
      courseId,
      deckId,
      result,
    }: {
      courseId: string;
      deckId: string;
      result: FlashcardAndStats;
    }) => {
      toggleFlashcardAnswer();
      queryClient.setQueryData(
        ['flashcardAndStats', courseId, deckId],
        (state: FlashcardAndStats) => ({
          ...state,
          flashcard: result.flashcard,
          ratingOptions: result.ratingOptions,
        }),
      );
      queryClient.setQueryData(
        ['flashcardDecksAndStats', courseId],
        (state: FlashcardDecksAndStats) => ({
          ...state,
          decks: state.decks.map((item) => {
            if (item.deck.id === deckId) {
              return {
                ...item,
                deck: {
                  ...item.deck,
                  stats: {
                    ...item.deck.stats,
                    ...result.deckStats,
                  },
                },
              };
            }
            return item;
          }),
          stats: {
            ...state.stats,
            newRemainingToday: result.allDecksStats.newRemainingToday,
          },
        }),
      );
    },
  });
}
